// extracted by mini-css-extract-plugin
export default {"optionLabel":"FlagInput_optionLabel__JDZtl","flag":"FlagInput_flag__-1lTm"};